<template>
  <div class="col-lg-12">
    <br />
    <b-row>
      <b-col class="text-left">
        <ScreensMenu />
      </b-col>
    </b-row>
    <br />
    <b-row v-if="loadingB">
      <b-col class="text-center">
        <b-spinner size="sm" variant="success"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col v-if="!log.length" class="text-center">
        <div
          style="
            background-color: #f0f3f5;
            padding: 0.75rem;
            vertical-align: top;
            border-top: 1px solid #f0f3f5;
          "
        >
          <div role="alert" aria-live="polite">
            <div class="text-center my-2">Sem registros para listar</div>
          </div>
        </div>
        <br />
      </b-col>
      <b-col v-else>
        <CardLogImportacao :log="log" />
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="lastItem">
        <b-button size="sm" variant="primary" @click="nextData()" :disabled="loadingNext">
          {{ loadingNext ? "Carregando..." : "Carregar mais +" }}
        </b-button>
      </b-col>
      <b-col v-else v-show="!loadingNext"> Sem registros para buscar... </b-col>
    </b-row>
  </div>
</template>

<script>
import CardLogImportacao from "./Exportacao/Etiqueta/CardLogExportacao.vue";
import ScreensMenu from "./ScreensMenu.vue";
import axios from "axios";
export default {
  components: { CardLogImportacao, ScreensMenu },
  data() {
    return {
      log: [],
      pagina: 0,
      loadingB: false,
      loadingNext: false,
      lastItem: null,
    };
  },
  beforeMount() {
    this.requestLabels();
  },
  methods: {
    nextData() {
      this.requestLabels(this.lastItem, true);
    },
    requestLabels(next = null, loadingB = false) {
      if (!loadingB) this.loadingB = true;
      this.loadingNext = true;

      let nextParam = "";
      if (next !== null) nextParam = `?next=${next}`;

      return axios
        .get(`/api/orders/export/labels/status${nextParam}`)
        .then((response) => {
          var data = response.data.labels;
          data.forEach((element) => {
            this.log.push(element);
          });
          const listName = "exportLabelsList";
          if (data.length > 0) {
            this.lastItem = data[data.length - 1].id;
          } else {
            this.lastItem = null;
          }
          if (!loadingB) this.loadingB = false;
          this.loadingNext = false;
        })
        .finally(() => {
          if (!loadingB) this.loadingB = false;
          this.loadingNext = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/ExportacoesEtiquetas.vue